import { render, staticRenderFns } from "./ORDER_EXAM.vue?vue&type=template&id=1312cab2"
import script from "./ORDER_EXAM.vue?vue&type=script&lang=js"
export * from "./ORDER_EXAM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports